module.exports = (function() {   
	setupGalleries();
	setupMovingGalleries();
})();

function setupGalleries() {
	var language = $("meta[name='site-language']").attr('content');
	$('.module-gallery').each(function() {
		var gallery = $(this);
		var id = $(this).attr('data-gallery-id');
		var url = window.lcb.config.apiPaths.PhotoGallery;
		url += id + "&langID=" + $("meta[name='language-id']").attr('content'); //PhotoGallery ID AND Language ID for the proper caption translation
		
		$.ajax({
	        url:url,
	        dataType: "text",
	        success: function(data) {
			    var json = $.parseJSON(data);
	            var galleryItems =  loadGalleryItems(json);
	            $(gallery).find('.magnific-popup').magnificPopup({      
			        items:galleryItems,
			        image: {
			            markup: '<div class="mfp-figure">' +
			                '<div class="gallery-title"></div>' +
			                '<div class="mfp-close"></div>' +
			                '<div class="mfp-img"></div>' +
			                '<div class="mfp-bottom-bar">' + json.title + ' ' +
			                '<div class="mfp-title"></div>' +
			                '<div class="gallery-counter-wrapper"></div>' +
			                '</div>' +
			                '</div>', // Popup HTML markup. `.mfp-img` div will be replaced with img tag

			            cursor: null, //'mfp-zoom-out-cur', // Class that adds zoom cursor, will be added to body. Set to null to disable zoom out cursor. 

			            titleSrc: 'title',
			            verticalFit: true, // Fits image in area vertically

			            tError: '<a href="%url%">The image</a> could not be loaded.' // Error message
			        },
			        showCloseBtn:false,
			        gallery: {
			            enabled: true
			        },
			        type: 'image'
			    });
	        },
	        error: function(e) {
	        	$(gallery).hide();
	        }
	    });
	 });
}

function setupMovingGalleries() {
	$("[data-moving-gallery]").each(function(index, movingGal) {
		var firstGrpItem = $("[data-group]:first", movingGal);
		firstGrpItem.wrap('<div class="cell medium-6 grid-y"></div>');
		firstGrpItem.parent().append($("[data-group]:not(:first)", movingGal).detach());
	});
}

function loadGalleryItems(data) {
	var items = [];	
	for (var i =0;i<data.items.length;i++) {           
        var caption =  data.items[i].caption;
        var url =  data.items[i].url;

        items[i] = {
            title: '<p>' + caption + '</p>',
            src: url
        };
    }       
    return items;         
}